import { useEffect } from 'react';

export default function useExitWarning(editMode, setEditMode) {
  history.pushState({}, '', location.href);

  useEffect(()=>{
    const removeBeforeUnload = () =>{
      window.removeEventListener('beforeunload',beforeUnload)
      window.removeEventListener('popstate', beforePopstate);
      window.removeEventListener('turbo:before-visit', turboBeforeUnload)
    }
    const beforeUnload = (e) => {
      e.preventDefault();
      msg = I18n.t('exit_now_warning');
      e.returnValue = msg;
      return msg;
    }
    const turboBeforeUnload = (e) => {
      if (window.confirm(I18n.t('exit_now_warning'))){
        removeBeforeUnload();
        return true;
      }
      e.preventDefault();
    }
    const beforePopstate = (e) => {
      if (window.confirm(I18n.t('exit_now_warning'))){
        removeBeforeUnload();
        setEditMode(false);
        return true;
      }
      history.pushState({}, '', location.href);
    }
    if (editMode){
      window.addEventListener('beforeunload',beforeUnload)
      window.addEventListener('popstate', beforePopstate);
      window.addEventListener('turbo:before-visit', turboBeforeUnload)
    } else {
      removeBeforeUnload();
    }

    return () => {
      removeBeforeUnload();
    }
  }, [editMode])
}
